import React from "react";
import { Link } from "react-router-dom";

const Features = () => {
  return (
    <div className="container-fluid bg-theme-primary m-0 py-4 py-md-5 px-1">
        <div className="container text-theme-light">
            <div className="section-header text-left mx-auto mb-5 " >
                <h1 className="section-heading text-theme-light">Industries We Serve In</h1>
                {/* <p>Tempor ut dolore lorem kasd vero ipsum sit eirmod sit. Ipsum diam justo sed rebum vero dolor duo.</p> */}
            </div>
            <div className="row g-4">
                <div className="col-6 col-lg-4 col-md-6" >
                    <div className="text-center h-100 text-theme-light category-item">
                        <img className="rounded img-fluid mb-2" src="../assets/images/ayurveda.jpg" alt="" />
                        <h6 className="mb-2 text-theme-light text-start">AYURVEDA</h6> 
                         <p className="s-description">Natural oils are deeply rooted in the Ayurveda industry and serve as basic elements in various therapies, personal care, and medicinal preparations. Here's a clear breakdown of their usefulness</p>
                        <Link to="blog/ayurveda" className="blog-link ms-auto text-light mb-1">
                         Know More </Link>
                    </div>
                </div>
                <div className="col-6 col-lg-4 col-md-6" data-wow-delay="0.3s">
                    <div className="text-center h-100 text-theme-light category-item">
                        <img className="rounded img-fluid mb-2" src="../assets/images/cosmetics.jpg" alt="" />
                        <h6 className="mb-2 text-theme-light text-start">COSMETICS</h6> 
                         <p className="s-description">At Deww Botanicals, we harness the transformative power of natural oils and plant butters to create clean, effective, and skin-loving cosmetic products. Rooted in purity and driven by Ayurvedic principles, our ingredients offer more than just beauty — they deliver wellness, nourishment, and long-term care.</p>
                        <Link to="blog/cosmetics" className="blog-link ms-auto text-light mb-1">
                         Know More </Link>
                    </div>
                </div>
                <div className="col-6 col-lg-4 col-md-6" data-wow-delay="0.5s">
                    <div className="text-center h-100 text-theme-light category-item">
                        <img className="rounded img-fluid mb-2" src="../assets/images/nutraceuticals.jpg" alt="" />
                        <h6 className="mb-2 text-theme-light text-start">NEUTRACEUTICALS</h6> 
                         <p className="s-description">Natural oils are becoming increasingly valuable in the nutraceuticals industry. Their natural origin, bioactive components, and multifunctional benefits make them ideal for health-focused supplements, functional foods, and wellness products.</p>
                        <Link to="blog/neutraceuticals" className="blog-link ms-auto text-light mb-1">
                         Know More </Link>
                    </div>
                </div>
                <div className="col-6 col-lg-4 col-md-6" data-wow-delay="0.5s">
                    <div className="text-center h-100 text-theme-light category-item">
                        <img className="rounded img-fluid mb-2" src="../assets/images/personal_care.jpg" alt="" />
                        <h6 className="mb-2 text-theme-light text-start">PERSONAL CARE</h6>
                         <p className="s-description">We believe that truly effective personal care starts with clean, plant-based ingredients. That’s why we formulate with the purest essential oils, carrier oils, liquid herbal extracts, and plant butters — each chosen for their time-tested benefits, therapeutic properties, and compatibility with skin and hairs.</p>
                        <Link to="blog/personal_care" className="blog-link ms-auto text-light mb-1">
                         Know More </Link>
                    </div>
                </div>
                <div className="col-6 col-lg-4 col-md-6" data-wow-delay="0.5s">
                    <div className="text-center h-100 text-theme-light category-item">
                        <img className="rounded img-fluid mb-2" src="../assets/images/herbaceuticals.jpg" alt="" />
                        <h6 className="mb-2 text-theme-light text-start">HERBACEUTICALS</h6>
                        <p className="s-description">As the herbaceuticals industry grows globally  blending traditional herbal wisdom with modern science our natural oils, extracts, and butters are becoming essential building blocks for high-efficacy formulations that support wellness, immunity, beauty, and vitality.</p>
                        <Link to="blog/herbaceuticals" className="blog-link ms-auto text-light mb-1">
                         Know More </Link>
                    </div>
                </div>
                <div className="col-6 col-lg-4 col-md-6" data-wow-delay="0.5s">
                    <div className="text-center h-100 text-theme-light category-item">
                        <img className="rounded img-fluid mb-2" src="../assets/images/food.jpg" alt="" />
                        <h6 className="mb-2 text-theme-light text-start">FOOD & BEVERAGES</h6>
                          <p className="s-description">Our range of natural essential oils, carrier oils, liquid extracts, oleoresins, and plant butters offers exceptional value to the food and beverage industry, combining flavor, function, and nutrition in every drop.</p>
                        <Link to="blog/food_beverages" className="blog-link ms-auto text-light mb-1">
                         Know More </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Features;
